// @flow
import React from 'react'
import styled from 'styled-components'
import { media } from 'src/theme/style-utils'
export const StyledRoomDetail = styled.div`
  height: 100vh;
`
export const RoomMasthead = styled.header`
  width: 100%;
  height: 400px;
  background-image: url(${(props: { header: string }) => props.header});
  background-position: right;
  background-size: cover;
  position: relative;

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: black;
    z-index: 0;
    ${media.tabletLarge`
      opacity:0.2;
    `}
  }
`
export const RoomBody = styled.article`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  max-width: 1200px;
  margin: auto;
  background-color: #fff;
  ${media.tabletLarge`
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 40px 80px;
  `};
`
export const ExpiredContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
  z-index: 100;
`
export const RoomDescription = styled.div`
  width: 100%;
  text-align: left;

  ${media.tabletLarge`
    text-align: center;
    width: 50%;
    padding-bottom: 100px;
  `};
`
export const StyledImage = styled.img`
  width: 100%;
  display: inline-block;
  margin: 60px 0;
`

export const JoinUsBanner = () => (
  <JoinUsBanner.Wrapper id="join_our_community_banner">
    <JoinUsBanner.Ele>
      <JoinUsBanner.Text>Join our community</JoinUsBanner.Text>
    </JoinUsBanner.Ele>
  </JoinUsBanner.Wrapper>
)

JoinUsBanner.Wrapper = styled.div`
  width: 100vw;
  height: 62px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 0;
  margin: auto;
  top: 117px;
  z-index: 1;

  display: none;
  ${media.tabletLarge`
      display:block;
    `}
`
JoinUsBanner.Ele = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  padding: 0 10px;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  ${media.tabletLarge`
  padding: 0 60px;
`}
`

JoinUsBanner.Text = styled.p`
  font-size: 48px;
  font-weight: 500;
  font-family: 'TheCollectiveBecome', 'RelativeFaux', 'Helvetica', 'Arial', sans-serif;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: white;
  margin: 0;
`



// WEBPACK FOOTER //
// ./src/components/RoomDetail/StyledRoomElements.js